<script setup lang="ts">
    import type {CardData} from "@songfinch/shared/types";
    import RoundImageWithDefault from "@songfinch/shared/components/RoundImageWithDefault.vue";
    import {useSongBuilderStore} from "@songfinch/customer/store_v2/useSongBuilderStore";
    const storeSongBuilder = useSongBuilderStore();

    defineProps<{
        cmsData?: CardData[]
    }>();

    const sliderOptions = {
        autoplay: true,
        autoHeight: true
    };

    function applyShortCodes(content: string) {
        return content
            .replace(/\[occasion\]/g, (storeSongBuilder.occasion?.toLowerCase() || ""))
            .replace(/\[relationship\]/g, (storeSongBuilder.relationship?.toLowerCase() || ""));
    }
</script>

<template>
    <Slider ref="slider" class="!@mb-4 cardSlider @mx-auto" :arrows="false" :options="sliderOptions">
        <SplideSlide v-for="(card, i) in cmsData" :key="i">
            <div class="@max-w-375 @mx-auto @p-6 @border @rounded-[12px] @flex @mt-4">
                <div v-if="card?.image" class="@w-full" :class="card.image_size === 'avatar' ? '@max-w-[64px] @mr-3' : '@max-w-[20px] @mr-2.5'">
                    <RoundImageWithDefault :class="card.image_size === 'avatar' ? '!@rounded-[8px] @shadow-[2px_2px_4px_0_rgba(0,0,0,0.25)]' : '!@bg-contain !@bg-no-repeat'" :image="card.image.url" not-round alt="Tip card icon"/>
                </div>
                <div class="cardContent p4 !@leading-[19px]" v-html="applyShortCodes(card.content)"/>
            </div>
        </SplideSlide>
    </Slider>
</template>

<style scoped>
    .cardSlider {
        max-width: 390px;

        .cardContent {
            :deep(p:last-of-type) {
                margin: 0;
            }
        }

        :deep(.splide__list){
            align-items: flex-end;
        }

        :deep(.splide__pagination) {
            bottom: -22px !important;
        }
    }
</style>

